import { render, staticRenderFns } from "./MetaMetricsIcon.vue?vue&type=template&id=396d1379&scoped=true"
import script from "./MetaMetricsIcon.vue?vue&type=script&lang=js"
export * from "./MetaMetricsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396d1379",
  null
  
)

export default component.exports